/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions(value) {
    if (!('SteamUserId' in value) || value['SteamUserId'] === undefined)
        return false;
    if (!('SteamSessionTicket' in value) || value['SteamSessionTicket'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SteamUserId': json['SteamUserId'],
        'SteamSessionTicket': json['SteamSessionTicket'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SteamUserId': value['SteamUserId'],
        'SteamSessionTicket': value['SteamSessionTicket'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateFromSocialSteamLoginOptions.js.map